<template>
  <div class="form-field">
    <label>对齐</label>
    <div class="content">
      <div class="options">
        <div :class="{'form-icon-button':true,active:style.align==='left'||!style.align}" @click="setAlign('left')">
          <i class="icon-align-left"><span class="path1"></span><span class="path2"></span></i>
        </div>
        <div :class="{'form-icon-button':true,active:style.align==='center'}" @click="setAlign('center')">
          <i class="icon-align-center"><span class="path1"></span><span class="path2"></span></i>
        </div>
        <div :class="{'form-icon-button':true,active:style.align==='right'}" @click="setAlign('right')">
          <i class="icon-align-right"><span class="path1"></span><span class="path2"></span></i>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .form-icon-button{
    border:0;
    >i{
      font-size:12px;
    }
    &.active{
      background: none;
      >i{
        color:#000;
      }
    }
  }
</style>

<script>
  import style from 'mixins/style'

  export default {
    mixins: [ style ],
    computed: {
		selected() {
			return this.$store.state.selected
		},
		style() {
			return this.$store.state.selected && this.$store.state.selected.style || {}
		},
    },
    methods:{
      setAlign(align){
		  this.$store.commit('update_elm_style', {
			  id: this.selected.id,
			  data: {
				  align
			  }
		  })
      }
    }
  }
</script>
